export const DISPATCH_POOL_ID = 'DISPATCH_POOL_ID';
export const DISPATCH_POOL_LOAD_ASSIGNMENT_DATE = 'DISPATCH_POOL_LOAD_ASSIGNMENT_DATE';
export const CPG_SHIFT_ID_FOR_MAP = 'shift_to_map';
export const CPG_PAYOUT_REQUEST_ID = 'CPG_PAYOUT_REQUEST_ID';
export const UFG_V3_LOAD_ID = 'UFG_V3_LOAD_ID';
export const SC_REDIRECTION_FACILITY_ID = 'SC_REDIRECTION_FACILITY_ID';
